<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
      

        <el-form-item label="商家ID">
          <el-input size="small" v-model="searchForm.supply_id" placeholder="商家ID搜索">
          </el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/category/add'">添加分类</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="category_id" default-expand-all :tree-props="{children: 'child'}"
          style="width: 100%" v-loading="loading">
          <el-table-column prop="supply_name" label="所属" width="180"></el-table-column>
          <el-table-column prop="name" label="分类名称" width="180"></el-table-column>
          <el-table-column prop="" label="图片" width="180">
            <template slot-scope="scope">
              <img v-img-url="hasImages(scope.row.images)" alt="" width="50px" />
            </template>
          </el-table-column>
          <el-table-column prop="product_num" label="商品数量"></el-table-column>
          <el-table-column prop="sort" label="分类排序"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>

                  <!-- 状态 (status) -->
                  <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                  <!-- 显示状态 0: 未处理, 1: 已处理 -->
                  <span>{{ scope.row.status === 0 ? '未开启' : '已开启' }}</span>
              </template>
          </el-table-column>

           <el-table-column prop="virtualInventoryAlert" label="状态">

              <template slot-scope="scope">
              <div> 
                <el-switch v-model="scope.row.status" active-color="#13ce66" 
          inactive-color="#ff4949"  @change="handleBlur(scope.row,'status')"
         :active-value="1" :inactive-value="0"></el-switch>
              </div>
              </template>
            </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/category/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/product/category/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Add from './Add.vue';
  import Edit from './Edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        categoryModel: {
          catList: [],
          model: {}
        },
        searchForm:{
          supply_id:""
        }
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {

      hasImages(e) {
        if (e) {
          return e.file_path;
        } else {
          return '';
        }
      },
      onSubmit(){
        this.getData();
      },
      /*获取列表*/
      getData() {
        let self = this;
        PorductApi.catList({
          supply_id:self.searchForm.supply_id
        }, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list;
            self.categoryModel.catList = self.tableData;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*打开添加*/
      addClick() {
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.categoryModel.model = item;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },
      /*删除分类*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          PorductApi.catDel({
            category_id: row.category_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },

      handleBlur(row,key){
        var self = this;
        PorductApi.editPart(
              {
                category_id: row.category_id,
                cond:[
                {
                  'key':key,
                  'val':row[key]
                }
                ]
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '修改成功',
                    type: 'success'
                  });
  
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });

      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/category/index.vue